import { PasscodeChallenge, PasscodeDigit } from '../authentication.service';
import { ActivateCardsRequest } from '../../models/card-activation';
import { JourneyType } from '../../models/journey-type';

export enum AuthenticationFactor {
  OTP = 'OTP',
  Passcode = 'Passcode',
  // @deprecated
  EmailOTP = 'EmailOTP',
  // @deprecated
  SMSOTP = 'SMSOTP',
}

export enum SecurityQuestionType {
  PreviousStatementBalance = 'PreviousStatementBalance',
  LastPaymentDue = 'LastPaymentDue',
  LastPaymentMade = 'LastPaymentMade',
  LastTransaction = 'LastTransaction',
}

export interface AskForAuthorizationResponse {
  isSuccessful: boolean;
  errors: Map<AuthenticationFactor, string>;
  signatureForRequestAndIsSuccessfulFlag: string;
}

export interface StepUpModel {
  passcodeDigits: PasscodeDigit[];
  otpValue?: string;
  verificationToken: string;
}

export interface ResendOTPResponse {
  isSuccessful: boolean;
  anyRetriesLeft: boolean;
}

export interface IOTPRequestBuilder {
  isResend: boolean;
}

export interface IOtpResponse {
  canResend: boolean;
  verificationToken: string;
}

export interface IStepUpResult {
  isSuccess: boolean;
  accountLocked: boolean;
  remainingAttempts: number;
}

export interface IStepUpResponse<TActionResult> {
  stepUpResult: IStepUpResult;
  actionResult: TActionResult;
}

export interface IScaChallenge {
  passcodeChallenge: PasscodeChallenge;
  isOtpRequired: boolean;
  canResend: boolean;
  verificationToken: string;
}

export interface IScaRequest {
  stepUpModel?: StepUpModel;
}

export interface IStepUpOtpRequest {
  verificationToken: string;
  channel: OtpChannel;
}

export interface IUsernameValidationRequest {
  username: string;
}

export interface IValidationResponse {
  result: boolean;
  error?: string;
}

export interface IRegisterAccountRequest {
  email: string;
  emailUpdated: boolean;
  username: string;
  password: string;
  passcode: string;
  token: string;
}

export interface IUserAccountDetails {
  lastName: string;
  postcode: string;
  cardNumber: string;
  cardExpiry: string;
  useAccountNumber: boolean;
  accountNumber: string;
  journey: JourneyType;
}

export interface IRegistrationDetailsResponse {
  isScaRequired: boolean;
  isTextOtpPossible: boolean;
  isCallOtpPossible: boolean;
  isEmailPossible: boolean;
  mobilePhone: string;
  homePhone: string;
  email: string;
  verificationToken: string;
}

export interface IRegistrationCodeAndOtpRequest {
  codeValue: string;
  otpValue: string;
  verificationToken: string;
}

export interface ISecurityQuestionAndOtpRequest {
  answerId: string;
  otpValue: string;
  verificationToken: string;
}

export interface IRegistrationScaResponse {
  isSuccess: boolean;
  accountLocked: boolean;
  remainingAttempts: number;
  email: string;
  verificationToken: string;
}

export interface IActivateCardsScaRequest extends ActivateCardsRequest {
  verificationToken: string;
}

export class ISendOtpRequest {
  channel: OtpChannel;
  verificationToken: string;
}

export class IResendOtpRequest {
  verificationToken: string;
}

export class IOtpChallenge {
  canResend: boolean;
  verificationToken: string;
}

export interface ISecurityQuestionAndOtpRequest {
  answerId: string;
  otpValue: string;
  verificationToken: string;
}

export interface IGetSecurityQuestionRequest {
  verificationToken: string;
}

export interface ISkipSecurityQuestionRequest {
  verificationToken: string;
}

export interface IResendRegistrationCodeRequest {
  verificationToken: string;
}

export interface IResendRegistrationCodeResponse {
  verificationToken: string;
  obfuscatedEmail: string;
  canResend: boolean;
}

export interface ISecurityQuestionAnswer {
  id: string;
  value: string;
}

export interface IGetSecurityQuestionResponse {
  isGenerated: boolean;
  question: SecurityQuestionType;
  paymentDate: Date;
  answers: ISecurityQuestionAnswer[];
  verificationToken: string;
}

export enum OtpChannel {
  Text,
  Call,
}

export enum AuthenticationLevel {
  PartialBound = 'partial_bound',
  PartialStepUp = 'partial_step_up',
  Full = 'full',
}
